import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import CouponsList from "./CouponsList.vue";
import NewCoupon from "./NewCoupon.vue";
export default {
  name: "Coupons.vue",
  components: {
    CouponsList: CouponsList,
    NewCoupon: NewCoupon
  },
  data: function data() {
    return {
      newCouponPopup: false
    };
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  methods: {
    couponCreated: function couponCreated(coupon) {
      this.$refs.couponsListRef.createCoupon(coupon);
      this.newCouponPopup = false;
    }
  }
};